import { BACKEND_URL } from '../config'
import { objectKeysToCamelCase } from '../common/case-style-conversion'
import $ from 'jquery'

const TWO_WEEKS = 60 * 60 * 24 * 14

class User {
  constructor(data) {
    Object.entries(data).forEach(([key, value]) => {
      this[key] = value
    })
  }

  static get url() {
    return `${BACKEND_URL}/accounts/users`
  }

  static get authKey() {
    return this.getCookie('auth_key')
  }

  static getCookies() {
    return document.cookie.split('; ').reduce((newCookies, cookie) => {
      const [attrName, value] = cookie.split('=')
      newCookies[attrName] = value
      return newCookies
    }, {})
  }

  static setCookies(name, value, maxAge) {
    if (maxAge) {
      document.cookie = `${name}=${value};path=/;max-age=${maxAge}`
    } else {
      document.cookie = `${name}=${value};path=/`
    }
  }

  static getCookie(name) {
    return this.getCookies()[name]
  }

  static removeAuthenticationCookie() {
    this.setCookies('auth_key', '')
  }

  static login(credentials) {
    return $.post({
      url: `${BACKEND_URL}/auth/login/`,
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(credentials)
    }).done(data => {
      this.setCookies('auth_key', data.key, TWO_WEEKS)
      return objectKeysToCamelCase(data)
    })
  }

  static async me() {
    return new Promise((resolve, reject) => {
      $.get(`${this.url}/me`)
        .done(data => resolve(new this(objectKeysToCamelCase(data))))
        .fail(reject)
    })
  }

  static logout() {
    return $.post(`${BACKEND_URL}/auth/logout/`)
      .always(() => this.removeAuthenticationCookie())
      .done(objectKeysToCamelCase)
  }

  static changePassword(password1, password2) {
    return $.post(`${BACKEND_URL}/auth/password/change/`, {
      new_password1: password1,
      new_password2: password2
    }).done(objectKeysToCamelCase)
  }

  static resetPassword(email) {
    return $.post(`${BACKEND_URL}/auth/password/reset/`, { email }).done(
      objectKeysToCamelCase
    )
  }

  static resetPasswordConfirm(uid, token, new_password1, new_password2) {
    return $.post(`${BACKEND_URL}/auth/password/reset/confirm/`, {
      uid,
      token,
      new_password1,
      new_password2
    }).done(objectKeysToCamelCase)
  }
}

export default User
